<div class="vcard">
	<div class="furtherInformations">
		<small>	{{ patent.priorityPatent ? ('fs.res.patent.Patent.priorityClaim' | hisUi) : ('fs.res.patent.Patent.priorityPatent' | hisUi) }}</small>
	      <small *ngIf="patent.status"> | {{ patent.status.defaulttext }} </small>
	      <ng-container *ngIf="isRegistered()"> <small> | Nr. {{patent.patentNumber}} | {{patent.registrationDate | date: dateFormat}}</small></ng-container>
	      <ng-container *ngIf="isGranted()"> <small> | {{ patent.grantDate | date: dateFormat}}</small></ng-container>
	      <ng-container *ngIf="isPublished()"> <small> | Nr. {{patent.publicationNumber}}</small></ng-container>
	      <ng-container *ngIf="isCountrySpecific(); else otherType;">
	       <small *ngIf="patent.country?.defaulttext "> | {{ patent.country.defaulttext }}</small>
	      </ng-container>
	      <ng-template #otherType><small> | {{ patent.registrationType.defaulttext }}</small></ng-template>
	</div>
	<h1><his-translated-text [hisobject]="patent" hisAttribute="title"></his-translated-text></h1>
	<div class="personAndOrganisation">
		<res-patent-view-inventors-details [patent]="isPriority() ? patent : patent.priorityPatent"></res-patent-view-inventors-details>
	</div>
	<br/>
</div>
